import { MonitorIcon } from "lucide-react";

export function SmallScreenMessage() {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <MonitorIcon className="size-12 text-muted-foreground" />
      <div>
        <h1 className="font-semibold text-lg">Please use a larger screen</h1>
        <p className="mt-1 text-muted-foreground text-sm">
          Gnomux requires a tablet or desktop browser.
        </p>
      </div>
    </div>
  );
}
